import styled from '@mui/system/styled'
import ListItemButton from '@mui/material/ListItemButton'

export const StyledListItemButton = styled(ListItemButton)`
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px;
`
